import React from "react";
import { List } from "antd";
import { useTranslation } from "react-i18next";
// Common
import peek from "assets/peeklex.png";
// Styling
import { CustomListItem, CustomImage, NumberBullet } from "./AfterSignUpStyle";

const AfterRegistrationStep1 = () => {
  const { t } = useTranslation("after_sign_up");
  const data = ["Confirm Time Zone", "Set language level", "Book fist class"];
  return (
    <div>
      <List
        split={false}
        dataSource={data}
        renderItem={(item, index) => (
          <CustomListItem>
            <NumberBullet>
              <p>{index + 1}</p>
            </NumberBullet>
            {t(item)}
          </CustomListItem>
        )}
      />
      <CustomImage src={peek} />
    </div>
  );
};

export default AfterRegistrationStep1;
